/**
 * CSH 2.0 Homepage JavaScript
 * Handles: carousel arrows, sticky header scroll, mega menu hover
 */

(function () {
  'use strict';

  // =========================================
  // Carousel arrow scroll + visibility
  // Shared by the annual/equipment carousels and the seasonal grid; any
  // wrapper marked [data-carousel] with a [data-carousel-track] and
  // [data-carousel-arrow] buttons gets horizontal scrolling with arrows
  // that hide at each end (and stay hidden when everything already fits).
  // =========================================
  function initCarousel(wrapper) {
    var track = wrapper.querySelector('[data-carousel-track]');
    if (!track) return;

    var prevBtn = wrapper.querySelector('[data-carousel-arrow][data-direction="prev"]');
    var nextBtn = wrapper.querySelector('[data-carousel-arrow][data-direction="next"]');

    function updateArrows() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (prevBtn) prevBtn.style.display = atStart ? 'none' : '';
      if (nextBtn) nextBtn.style.display = atEnd ? 'none' : '';
    }

    updateArrows();
    track.addEventListener('scroll', updateArrows, { passive: true });

    wrapper.querySelectorAll('[data-carousel-arrow]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = track.querySelector('.csh-product-card');
        if (!card) return;

        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var scrollAmount = card.offsetWidth + gap;
        var direction = button.dataset.direction === 'prev' ? -1 : 1;

        track.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
      });
    });
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  // =========================================
  // Sticky header — scroll detection
  // =========================================
  var header = document.querySelector('.site-header');
  if (header) {
    var announcementBar = document.querySelector('.shopify-section-announcement-bar, [class*="announcement"]');
    var announcementHeight = announcementBar ? announcementBar.offsetHeight : 44;

    window.addEventListener('scroll', function () {
      if (window.scrollY >= announcementHeight) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // =========================================
  // Pointer-drag scroll for horizontal sliders.
  // Touch devices use native scroll; mouse + pen drag via pointer events.
  // The drag threshold preserves clicks on links inside slides.
  // =========================================
  function initPointerDrag(container) {
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    container.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = container.scrollLeft;
      // Don't capture the pointer or flag dragging until movement
      // exceeds the threshold — otherwise clicks on links/buttons get
      // redirected to the container and never navigate.
    });

    // Block native image drag-and-drop so the browser doesn't ghost
    // an image away while the user is trying to scroll the slider.
    container.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Listen on window so the drag continues if the pointer leaves the
    // container, and ends correctly even when released outside.
    window.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerType === 'touch') return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) <= 8) return;
      if (!moved) container.classList.add('is-dragging');
      moved = true;
      container.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function endDrag () {
      if (!isDown) return;
      isDown = false;
      container.classList.remove('is-dragging');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // If we actually dragged, swallow the resulting click so links
    // don't navigate. A pure click never sets `moved`, so it passes
    // through naturally.
    container.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  document.querySelectorAll(
    '.template-locations-csh multiple-media-with-text, ' +
    '.template-locations-csh .multiple-media-with-text, ' +
    '.template-locations-csh .multiple-media-with-text__media-wrapper'
  ).forEach(function (container) {
    initPointerDrag(container);

    // Open address-slide links (directions, Beiko, etc.) in a new tab.
    container.querySelectorAll('a[href]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });

  // Any track that opts in — currently the product gallery thumbnails.
  document.querySelectorAll('[data-drag-scroll]').forEach(initPointerDrag);

  // =========================================
  // Mega menu hover — activate header bg
  // =========================================
  var megaTrigger = document.querySelector('.header__nav-item--has-mega');
  if (megaTrigger && header) {
    megaTrigger.addEventListener('mouseenter', function () {
      header.classList.add('is-mega-open');
    });
    megaTrigger.addEventListener('mouseleave', function () {
      header.classList.remove('is-mega-open');
    });
  }
})();
